export default __webpack_public_path__ + "static/chiller_b.2cf48a6a78f47b342b17c0fe79b52b31.png";